import {
  GetSpecialServiceDetailsResponse,
  SpecialServiceDetails,
  SpecialServiceDetailsFromBE,
} from 'api/premiumUserAPI/specialServicesAPI'
import { CallAPIAction, Status } from 'api/types'
import { GeneralFailResponse } from 'common/types/commonTypes'
import Actions from 'redux/actions'

type State = {
  specialService?: SpecialServiceDetails
} & Status

const initialState: State = {
  specialService: undefined,
  isLoading: false,
  success: false,
  fail: false,
}

const convertResponseToState = (res: SpecialServiceDetailsFromBE): SpecialServiceDetails => ({
  comments: res?.comments
    ? res.comments.map((comment) => ({
        createdAt: comment.created_at,
        files: comment.files.map((file) => ({
          fileName: file.file_name,
          url: file.url,
        })),
        comment: comment.comment,
        author: {
          name: comment.author.name,
        },
      }))
    : null,
  displayId: res.display_id,
  destination: res.destination,
  details: res.details,
  status: res.status,
  description: res.description,
  inquiry: res.inquiry,
  files: res?.files
    ? res.files.map((file) => ({
        fileName: file.file_name,
        url: file.url,
      }))
    : null,
  governmentAgency: res.government_agency
    ? {
        id: res.government_agency.id,
        label: res.government_agency.label,
        labelEn: res.government_agency.label_en,
      }
    : null,
  consultancyType: res.consultancy_type
    ? {
        id: res.consultancy_type.id,
        label: res.consultancy_type.label,
        labelEn: res.consultancy_type.label_en,
      }
    : null,
  premiumUser: {
    name: res.premium_user.name,
    idNumber: res.premium_user.id_number,
    mobile: res.premium_user.mobile,
    relationshipManager: res.premium_user?.relationship_manager
      ? {
          name: res.premium_user.relationship_manager.name,
          mobile: res.premium_user.relationship_manager.mobile,
        }
      : null,
  },
  completedAt: res.completed_at,
  createdAt: res.created_at,
})

export default (
  state: State = initialState,
  action: CallAPIAction<
    Actions.GET_SPECIAL_SERVICE_DETAILS_ASYNC,
    Actions.GET_SPECIAL_SERVICE_DETAILS_SUCCESS,
    Actions.GET_SPECIAL_SERVICE_DETAILS_FAIL,
    GetSpecialServiceDetailsResponse,
    GeneralFailResponse
  >,
) => {
  switch (action.type) {
    case Actions.GET_SPECIAL_SERVICE_DETAILS_ASYNC:
    case Actions.GET_SPECIAL_SERVICE_DETAILS_FAIL: {
      return {
        ...state,
        ...action.status,
      }
    }
    case Actions.GET_SPECIAL_SERVICE_DETAILS_SUCCESS:
      return {
        ...state,
        ...action.status,
        specialService: convertResponseToState(action.payload.data),
      }

    default:
      return state
  }
}
